import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6f68d5f3")

_pushScopeId("data-v-6f68d5f3")
const _hoisted_1 = { class: "add" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_add_button = _resolveComponent("add-button")
  const _component_list = _resolveComponent("list")
  const _component_camera_devices_operate_dialog = _resolveComponent("camera-devices-operate-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_add_button, { onClick: _ctx.add }, null, 8, ["onClick"])
    ]),
    _createVNode(_component_list, {
      headers: _ctx.column,
      "list-data": _ctx.tableData,
      "show-default-action": [],
      action: _ctx.action,
      update: _ctx.updateData,
      "show-check": false
    }, {
      LocationSlotHeader: _withId((data) => [
        _createVNode("div", {
          class: "sort-header",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getSortRes('aptInfoThirdPartyDevice', 'Location')))
        }, [
          _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
          _createVNode("img", {
            src: _ctx.getSortImg('aptInfoThirdPartyDevice', 'Location')
          }, null, 8, ["src"])
        ])
      ]),
      CreateTimeSlotHeader: _withId((data) => [
        _createVNode("div", {
          class: "sort-header",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getSortRes('aptInfoThirdPartyDevice', 'CreateTime')))
        }, [
          _createTextVNode(_toDisplayString(data.scope.label) + " ", 1),
          _createVNode("img", {
            src: _ctx.getSortImg('aptInfoThirdPartyDevice', 'CreateTime')
          }, null, 8, ["src"])
        ])
      ]),
      _: 1
    }, 8, ["headers", "list-data", "action", "update"]),
    (_ctx.isShowOperateDialog)
      ? (_openBlock(), _createBlock(_component_camera_devices_operate_dialog, {
          key: 0,
          operate: _ctx.operateType,
          grade: 3,
          "personal-account-id": _ctx.uuid,
          "camera-info": _ctx.editData,
          onSuccess: _ctx.getThirdPartyDeviceApi,
          onClose: _ctx.cameraClose
        }, null, 8, ["operate", "personal-account-id", "camera-info", "onSuccess", "onClose"]))
      : _createCommentVNode("", true)
  ]))
})